import type { Message } from "../locale.ts";
import { m } from "../paraglide/messages.js";

export const DEMO_REFUSALS = {
  demo_billing: m.demo_refused_billing,
  demo_workspace: m.demo_refused_workspace,
  demo_upload: m.demo_refused_upload,
  demo_import: m.demo_refused_import,
  demo_unavailable: m.demo_refused,
} as const satisfies Readonly<Record<string, Message>>;

export type DemoRefusal = keyof typeof DEMO_REFUSALS;

export const demoRefusal = (code: string | null): string | null =>
  code !== null && Object.hasOwn(DEMO_REFUSALS, code) ? DEMO_REFUSALS[code as DemoRefusal]() : null;
